import styled from '@emotion/styled'
import {PALETTE} from '../styles/paletteV3'

const TinyLabel = styled('label')({
  color: PALETTE.SLATE_600,
  fontSize: 11
})

export default TinyLabel
